import { DashboardInformationFactory } from '@/inventoryDashboardModule/domains/factories/DashboardInformationFactory';
import { IInventoryDashboardState, ViewType } from './types';
import { DateService } from '@/coreDomainsModule/services/dateService';
import { DEFAULT_DISPLAY_MONTH_PERIOD_FROM, DEFAULT_DISPLAY_MONTH_PERIOD_TO } from '@/inventoryDashboardModule/constants';

/**
 * InventoryDashboardのStateを初期化する関数
 * @returns - 初期状態のIInventoryDashboardState型のオブジェクト
 */
export const initInventoryDashboardState = (): IInventoryDashboardState => {
  return {
    nowViewType: ViewType.Graph,
    displayYearMonth: DateService.getShiftedIYearMonthFromNowDateByMonths(0),
    displayYearMonthPeriod: [
      DateService.getShiftedIYearMonthFromNowDateByMonths(DEFAULT_DISPLAY_MONTH_PERIOD_FROM),
      DateService.getShiftedIYearMonthFromNowDateByMonths(DEFAULT_DISPLAY_MONTH_PERIOD_TO),
    ],
    forecastAccuracyPeriod: undefined,
    filterItems: [],
    checkedBusinessId: [],
    overviewData: {
      totalCurrentInventoryAmount: undefined,
      averageTurnover: undefined,
      averageForecastAccuracy: undefined,
      averageKpiArchievementRate: undefined,
      warningItemsCount: undefined,
      criticalItemsCount: undefined,
    },
    information: DashboardInformationFactory.create(),
    informationLoadingState: { status: { type: 'none' } },
  };
};
